<!--
  创建时间：2024/10/25 上午11:20
  创建人：toyeh
  文件描述：SearchResult
-->

<template>
  <div class="def-w">
    <div class="search-result-container">
      <h2>搜索结果</h2>
      <ul v-if="list.length > 0">
        <li v-for="(item) in list" :key="item.id">
          <a :href="computedRouteLink(item)" class="f-b-c list-item" target="_blank" :title="item.title">
            <div class="tag bg_primary mr-10">{{ getMenuName(item) }}</div>
            <h3 class="text-cut fc33">{{ item.title }}</h3>
            <div class="time fc99 ml-10">{{ item.releaseTime }}</div>
          </a>
        </li>
      </ul>
      <div v-else style="height: 450px">
        <no-data />
      </div>
    </div>
    <info-pagination
      :total="total"
      :current-page.sync="curPage"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
    />
  </div>

</template>

<script>
import NoData from "@/components/NoData.vue";
import infoApi from "@/api/information";
import { TOP_NAV_MENU_CODE } from "@/utils/constant";
import { parseTime } from "@/utils/common";
import { mapGetters } from "vuex";
import InfoPagination from "@/components/InfoPagination.vue";

export default {
  name: "SearchResult",
  components: { InfoPagination, NoData },
  props: {
  },
  data() {
    return {
      list: [],
      curPage: 1,
      curSdPage: 1,
      pageSize: 20,
      total: 0
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["allMenusList","allMenusTree"]),
    
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList()
  },
  // 方法集合
  methods: {
    computedRouteLink(item) {
      const menuItem = this.getItemMenuById(item.columnId)
      return `/info/detail/${menuItem.code}?id=${item.id}`
    },
    getColumnId(code) {
      return this.allMenusList.filter(item => item.code === code)[0]?.id || "";
    },
    getItemMenuById(columnId) {
      return this.allMenusList.find(item => item.id === columnId) || {};
    },
    getMenuLevel(menuId, menusTree) {
        const findLevel = (id, tree, level = 1) => {
          for (const item of tree) {
            if (item.id === id) {
              return level;
            }
            if (item.children && item.children.length > 0) {
              const childLevel = findLevel(id, item.children, level + 1);
              if (childLevel) {
                return childLevel;
              }
            }
          }
          return null;
        };
        return findLevel(menuId, menusTree);
    },
    getMenuName(item) {
      const level = this.getMenuLevel(item.columnId, this.allMenusTree);
      if (level === 3) {
        const findParent = (id, tree) => {
          for (const node of tree) {
            if (node.children && node.children.some(child => child.id === id)) {
              return node.name; // 返回二级菜单的 name
            }
            if (node.children && node.children.length > 0) {
              const parentName = findParent(id, node.children);
              if (parentName) {
                return parentName;
              }
            }
          }
          return null;
        };
        const parentName = findParent(item.columnId, this.allMenusTree) || "未知分类";
        const currentName = this.getItemMenuById(item.columnId).name || "未知分类";
        return `${parentName} - ${currentName}`;
      }else{
        return this.getItemMenuById(item.columnId).name;
      }
    },
    // 获取列表
    getList() {
      infoApi.page({
        pageNo: this.curPage,
        pageSize: this.pageSize,
        excludeColumnId: this.getColumnId(this.$route.query.excludeColumnId),
        title: this.$route.query.title,
        isColumnChild: Object.values(TOP_NAV_MENU_CODE).includes(this.$route.params.code)
      }).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          this.total = data.total
          list.forEach(item => {
            item.releaseTime = parseTime(item.releaseTime, "{y}-{m}-{d}")
          })
          this.list = data.list
        }
      })
    },
    // 翻页
    handleCurrentChange(val) {
      this.curPage = val
      this.getList()
    }
  }
};
</script>

<style scoped lang="scss">
.search-result-container{
	border: 1px solid #eee;
	padding: 0 20px;
	h2{
		height: 60px;
		line-height: 60px;
		border-bottom: 2px solid #eee;
		position: relative;
		color: $--color-primary;
		font-size: 24px;
		font-weight: bold;
		&:before{
			content: "";
			display: block;
			width: 100px;
			height: 2px;
			position: absolute;
			left: 0;
			bottom: 0;
			transform: translateY(100%);
			background-color: $--color-primary;
		}
	}
	ul {
		.list-item{
			height: 50px;
			line-height: 50px;
			border-bottom: 1px solid #eee;
			.tag{
				width: 115px;
				height: 22px;
				color: #fff;
				background-color: $--color-primary;
				border-radius: 4px;
				line-height: 22px;
				font-size: 12px;
				text-align: center;
				flex-shrink: 0;
			}
			h3{
				flex: 1;
				font-weight: normal;
				font-size: 14px;
			}
			.time{
				width: 80px;
				text-align: right;
				font-size: 14px;
				flex-shrink: 0;
			}
			&:hover{
				h3{
					color: $--color-primary;
				}
			}
		}
	}
}
</style>
